var $ = jQuery.noConflict();